<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-15 15:45:37
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-17 18:23:25
 * @FilePath: /dsicm-admin-web/src/layout/NavMenu.vue
-->

<template>
  <el-submenu :index="data.component">
    <template slot="title">
      <i class="el-icon-location"></i>
      <span slot="title">{{data.name}}</span>
    </template>

    <template v-for="item in data.children">

      <NavMenu v-if="item.children.length" :data="item" :key="item.id" />
      <!-- 当还有下级菜单时调用组件本身 递归出口：当没有下级菜单时跳出递归，完成渲染最外面层的菜单 -->

      <el-menu-item v-else :index="item.component" :key="item.id" class="last-menu" @click="changeMenu">
        <span>{{ item.name }}</span>
        <!-- leftMenuNumber.smallRoomMsgNumber > 99 ? 99 : leftMenuNumber.smallRoomMsgNumber -->
        <span class="sign-msg"
          v-if="item.component === '/case-2' && leftMenuNumber.smallRoomMsgNumber">{{ leftMenuNumber.smallRoomMsgNumber > 99 ? defalultNum : leftMenuNumber.smallRoomMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/case-5' && leftMenuNumber.patientFilesMsgNumber">{{ leftMenuNumber.patientFilesMsgNumber > 99 ? defalultNum : leftMenuNumber.patientFilesMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/case-6' && leftMenuNumber.clockInMsgNumber">{{ leftMenuNumber.clockInMsgNumber > 99 ? defalultNum : leftMenuNumber.clockInMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/case-4' && leftMenuNumber.feedbackMsgNumber">{{ leftMenuNumber.feedbackMsgNumber > 99 ? defalultNum : leftMenuNumber.feedbackMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/case' && leftMenuNumber.intoCaseMsgNumber">{{ leftMenuNumber.intoCaseMsgNumber > 99  ? defalultNum : leftMenuNumber.intoCaseMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/case-3' && leftMenuNumber.taskMsgNumber">{{ leftMenuNumber.taskMsgNumber > 99  ? defalultNum : leftMenuNumber.taskMsgNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/Organization/feedback' && opinionFeedbackNum">{{ opinionFeedbackNum > 99 ? defalultNum : opinionFeedbackNum}}</span>
        <!-- 医护对话-需对接口字段 -->
        <span class="sign-msg"
          v-if="item.component === '/case-8' && leftMenuNumber.doctorNurseNumber">{{ leftMenuNumber.doctorNurseNumber > 99 ? defalultNum : leftMenuNumber.doctorNurseNumber }}</span>
        <span class="sign-msg"
          v-if="item.component === '/customer'&& customerServiceNumber">{{ customerServiceNumber > 99 ? defalultNum : customerServiceNumber }}</span>
        <!-- 患友互动增加角标 /termPage/interaction -->
        <span class="sign-msg"
          v-if="item.component === '/termPage/interaction'&& interactionNumber">{{ interactionNumber > 99 ? defalultNum : interactionNumber }}</span>
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: "NavMenu",
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    interactionNumber: {
      type: Number
    }
  },
  data() {
    return {
      defalultNum: 99 + "+",
      leftMenuNumber: {},
      currentEnv: "",
      opinionFeedbackNum: "",
      customerServiceNumber: ""
    };
  },
  watch: {
    "$websocket.state.leftMenuNumber"(val) {
      this.leftMenuNumber = val;
    },
    "$websocket.state.opinionFeedbackNum"(val) {
      this.opinionFeedbackNum = val;
    },
    "$websocket.state.customerServiceNumber"(val) {
      this.customerServiceNumber = val;
    }
  },
  mounted() {
    this.leftMenuNumber = this.$websocket.state.leftMenuNumber;
    this.opinionFeedbackNum = this.$websocket.state.opinionFeedbackNum;
    this.customerServiceNumber = this.$websocket.state.customerServiceNumber;
    this.currentEnv = process.env.NODE_ENV;
  },
  methods:{
    //切换菜单解锁用户占用的所有房间
    changeMenu(){ 
      this.$socket.emit( "unlock",'',data => {});
    }
  }
};
</script>
<style lang="less" scoped>
.el-menu-item.is-active {
  background-color: #1a7bfc !important;
  color: #fff !important;
}
.last-menu {
  // display: flex;
  .sign-msg {
    width: 24px;
    height: 24px;
    background: #f14352;
    font-size: 12px;
    line-height: 24px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    float: right;
    margin-top: 16px;
  }
}
</style>
